/**
 * Vector format is [a, b]
 */
export class Vector2 {
    constructor(a, b) {
        Object.defineProperty(this, "a", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "b", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.a = a;
        this.b = b;
    }
    normalize() {
        const length = this.magnitude();
        return new Vector2(this.a / length, this.b / length);
    }
    dotProduct(other) {
        return this.a * other.a + this.b * other.b;
    }
    crossProduct(other) {
        return this.a * other.b - this.b * other.a;
    }
    magnitude() {
        return Math.sqrt(Math.pow(this.a, 2) + Math.pow(this.b, 2));
    }
}
//# sourceMappingURL=Vector2.js.map